import { RowClickOptions } from '@/ui/molecules/data-table/DataTable'
import { TokenSymbolEnum } from '@/utils/tokens'
import { Address } from 'viem'
import { z } from 'zod'

export interface Activity {
  protocol: string
  img: string
  multiplier: number
  activity: string
}

export interface HPPointsTableData extends Activity {
  externalHref?: string
  address: string
  type: string
  rowClickOptions: RowClickOptions
}

export interface PartnersIsolatedActivity extends Activity {
  pairAddress: Address
  pairedWith: TokenSymbolEnum
  pointsIcon: string
}

type PartnersPooledActivity = Activity & {
  address: string
  pointsIcon: string
}

export type PartnersPointsTableData = PartnersIsolatedActivity | PartnersPooledActivity

export const FuulPointsLeaderboardSchema = z.object({
  address: z.string(),
  affiliate_code: z.string().nullable().optional(),
  total_amount: z.coerce.number(),
  rank: z.number(),
  total_attributions: z.number(),
  tiers: z.record(z.string(), z.string()).optional(),
  referred_volume: z.string().optional(),
})

export const LeaderboardResponseSchema = z.object({
  total_results: z.number(),
  page: z.number(),
  page_size: z.number(),
  results: z.array(FuulPointsLeaderboardSchema),
})

export const UserPointsLeaderboardResponseSchema = LeaderboardResponseSchema.extend({
  calculated_at: z.string().datetime().optional(),
})

export type FuulPointsLeaderboard = z.infer<typeof FuulPointsLeaderboardSchema>
export type PointsLeaderboard = z.infer<typeof LeaderboardResponseSchema>
export type UserPointsLeaderboardResponse = z.infer<typeof UserPointsLeaderboardResponseSchema>
export type UserPoints = FuulPointsLeaderboard
